export const CLASS_TYPES = {
  TOP: 'top',
  BOTTOM: 'bottom',
  FLEX_DATE: 'flex-date'
};
